// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {translate} from '../../../../shared/services/translation-service';

function handleChange(event) {

    this.onChange(event.target.value);

}

const LabeledTextArea = ({className, highlightClass, isEditable, value, label, vsrMessage, ...props}) =>
    <LabeledFormInput
        className={`${className} ${highlightClass}`}
        label={label}
    >
        <EditableField
            className={'preformatted'}
            isEditable={isEditable}
            value={value}
        >
            <textarea
                {...props}
                onChange={props::handleChange}
                value={value}
            />
        </EditableField>
        {
            vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledTextArea.displayName = 'LabeledTextArea';
LabeledTextArea.propTypes = {
    className: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledTextArea;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-text-area.js